import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=2a0e4060"
import script from "./message-box.vue?vue&type=script&lang=js"
export * from "./message-box.vue?vue&type=script&lang=js"
import style0 from "./message-box.vue?vue&type=style&index=0&id=2a0e4060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports